import { Mapper } from '../../utilitis/base/mapper';
import { CityEntitie } from '../entities/city.entitie';
import { CityModel } from '../../domain/models/city.model';

export class CityMapper extends Mapper<
    CityEntitie[] | CityEntitie,
    CityModel[] | CityModel
> {
    mapperArrayFrom(payload: CityEntitie[]): CityModel[] {
        let cityFormat: CityModel[] = [];

        payload.forEach((element: CityEntitie) => {
            cityFormat.push({
                id: element.id,
                name: element.name,
            });
        });

        return cityFormat;
    }

    mapperArrayTo(payload: CityModel[]): CityEntitie[] {
        let cityFormat: CityEntitie[] = [];

        payload.forEach((element: CityModel) => {
            cityFormat.push({
                id: element.id,
                name: element.name,
            });
        });

        return cityFormat;
    }

    mapperFrom(payload: CityEntitie): CityModel {
        return {
            id: payload.id,
            name: payload.name,
        };
    }

    mapperTo(payload: CityModel): CityEntitie {
        return {
            id: payload.id,
            name: payload.name,
        };
    }
}
